import type { ComponentProps } from "react"

import { SCHEME_ATTRIBUTE, type ColorScheme } from "@/lib/color-scheme/scheme"

interface SchemeScopeProps extends ComponentProps<"div"> {
  scheme: ColorScheme
}

export const SchemeScope = ({ scheme, ...props }: SchemeScopeProps) => <div {...{ [SCHEME_ATTRIBUTE]: scheme }} {...props} />
